module.exports = __webpack_public_path__ + "c1e177a1dcaa8713e4a41f44f67e3da9.png";